// hooks/useTrackVideo.ts
import { QueryClient, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getAllTrackVideo, trackVideoEvent, TrackVideoPayload } from "../api/trackLMSApi";

const trackDB = process.env.REACT_APP_DATABASE;

export const useTrackVideo = () => {
  return useMutation({
    mutationFn: (payload: TrackVideoPayload) => trackVideoEvent(payload),
  });
};

export const useTrackList = (id: any, moodleUser: any) => {
  return useQuery({
    queryKey: ["track-video", id],
    queryFn: () =>
      getAllTrackVideo({
        userid: moodleUser?.id,
        courseid: id,
      }),
    enabled: !!id,
    select: (res) => res?.result || [], // 👈 lấy thẳng mảng video
  });
};
